let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("j1unk")).then(() => parcelRequire('iO1k1'));